import axios from "axios";
import { create } from "zustand";

const contactUsStore = create((set) => ({
  contactUsList: null,
  isLoading: true,

  fetchAllContactUs: async () => {
    // Fetch contact us
    const res = await axios.get("/fetch-all-contact-us");
    // set contact us to state
    if (res.data.contact_us.length) {
      set({ contactUsList: res.data.contact_us });
    }
    set({ isLoading: false });
  },

  updateReplyContactUs: async ({
    _id,
    emailTo,
    subject,
    message,
    customerName,
    brandName,
  }) => {
    try {
      const isEmailSend = await axios.post("/send-mail-contact-us-reply", {
        emailTo,
        subject,
        message,
        customerName,
        brandName,
      });
      if (isEmailSend) {
        const res = await axios.put(`/update-reply-contact-us/${_id}`, {
          subject,
          message,
        });

        if (res) {
          set({ contactUsList: res.data.contact_us });
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } catch (error) {
      console.log(error);
      return false;
    }
  },
}));

export default contactUsStore;
